import * as React from 'react';

import * as styles from './LocationModalHeader.css';

export const LocationModalHeader: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['header']}>{children}</div>;
};
